<script>
import Underline from "@/components/parts/Underline"
import Quote from "@/components/parts/Quote"

export default {
  name: "Education",
  components: {
    Underline,
    Quote,
  }
}
</script>

<template>
  <div class="py-10 px-6 lg:w-2/3 lg:mx-auto">
    <h1 class="ts font-bold line120 text-primary">Focus on Education</h1>
    <Underline class="flex w-16 h-1.5 mt-4 mb-6 md:mb-8 bg-accent" />
    <div class="text more p text-gray-700 lg:w-5/6 lg:ml-auto">
      <p>We decided to help children as they are the most vulnerable people in the world.</p>
      <p>And they are the future.</p>
      <p>So investing in their education is something that they’ll forever have.</p>
      <p>A gift that cannot be taken away.</p>
      <p>Education will give them self-confidence, a wider knowledge to understand everything better, a global vision in life and freedom to travel and go for the future they want and deserve.<p/>
    </div>
    <Quote
      class="pt-16 pb-12"
      text='"Education is not preparation for life; education is life itself"'
      author="John Dewey"
    />
  </div>
</template>

<style scoped>
.p p {
  padding-bottom: 1rem;
}

.more {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 170%;
  letter-spacing: 0.4px;
}

@media screen and (min-width: 767px) {
  .more {
    font-size: 18px;
  }
}
</style>